import React from "react";
import Spinner from "sushiweb/Spinner/Spinner";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";

const SpinLoader = () => {
  return (
    <SpinLoading>
      <Spinner color={variables.primaryColor} size={"medium"} />
    </SpinLoading>
  );
};

const SpinLoading = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10;
`;

export default SpinLoader;
